import { GridStack } from 'gridstack';
import { easepick, RangePlugin } from '@easepick/bundle';

import utils from './utils';
import graphics from './graphics';
import ReportUtils from './reports';

class ReportRender {
    constructor()
    {
        this.grid = null;
        this.picker = null;
        this.reports = new ReportUtils();
    }

    updateDateRange()
    {
        let wrapper = $('#date-range-calendar');
        let block = wrapper.siblings('.date-range').first().clone().prop('hidden', false);
        let start = new Date(wrapper.attr('data-start'));
        let end = new Date(wrapper.attr('data-end'));
        block.find('input[name=range-start]').val(start.toISOString().slice(0, 10));
        block.find('input[name=range-end]').val(end.toISOString().slice(0, 10));
        wrapper.empty().append(block);
        return [start, end];
    }

    updateDates(container, start, end, interval)
    {
        if (this.picker) {
            this.picker.setStartDate(start);
            this.picker.setEndDate(end);
        }

        let wrapper = $('#date-range-calendar');
        wrapper.attr('data-start', start);
        wrapper.attr('data-end', end);
        wrapper.attr('data-interval', interval);
        this.updateDateRange();

        let subject = $('[name=subject]').val();
        this.reports.loadCells(this.grid, container, 'render', subject);
    }

    currentDatesLabel(button)
    {
        button.closest('ul').find('li a').removeClass('active');
        button.addClass('active');
        $('.date-range-simplified-label').text(button.text());
    }

    formatDate(d) {
        var month = '' + (d.getMonth() + 1);
        var day = '' + d.getDate();
        var year = d.getFullYear();

        if (month.length < 2) {
            month = '0' + month;
        }

        if (day.length < 2) {
            day = '0' + day;
        }

        return [year, month, day].join('-');
    }

    initReportRenderer(container)
    {
        let editor = $('#report-render', container);
        if (editor.length > 0) {
            /*
                L'inizializzazione del calendario EasyPick va fatta quando il
                menu viene effettivamente visualizzato, altrimenti non sa
                calcolarsi le dimensioni del box
            */
            $('.date-range-panel').one('show.bs.dropdown', () => {
                const dates = this.updateDateRange();

                const elem = document.getElementById('date-range-calendar');

                this.picker = new easepick.create({
                    element: elem,
                    css: [
                        $('input[name="calendar-css"]').val()
                    ],
                    plugins: [RangePlugin],
                    inline: true,
                    grid: 1,
                    calendars: 1,
                    lang: 'it-IT',
                    RangePlugin: {
                        startDate: dates[0],
                        endDate: dates[1],
                        tooltip: false,
                    }
                });

                this.picker.on('select', () => {
                    let button = $('.date-range-panel');
                    this.currentDatesLabel(button);

                    let start = this.picker.getStartDate();
                    let end = this.picker.getEndDate();
                    this.updateDates(container, this.formatDate(start), this.formatDate(end), '');
                });

                this.updateDateRange();
            }).siblings('.dropdown-menu').on('click', (e) => e.stopPropagation());

            container.on('blur', '.date-range input[type=date]', (e) => {
                let input = $(e.currentTarget);
                let row = input.closest('.date-range');
                let start = row.find('[name=range-start]').val();
                let end = row.find('[name=range-end]').val();
                this.updateDates(container, start, end, '');
            });

            $('.triggers-daterange', container).click((e) => {
                let button = $(e.currentTarget);
                this.currentDatesLabel(button);

                let start = button.attr('data-start');
                let end = button.attr('data-end');
                let interval = button.attr('data-interval');
                this.updateDates(container, start, end, interval);
            });

            /*
                Atomic height of cells is dynamically calculated due the size
                of the window. 9 rows is by design
            */

            let cell_height = (window.innerHeight - $('#report-render').offset().top - 20) / 9;

            this.grid = GridStack.init({
                minRow: 1,
                cellHeight: cell_height + 'px',
                acceptWidgets: false,
                disableDrag: true,
                disableResize: true,
            });

            this.grid.load(window.layout);

            let subject = $('[name=subject]').val();
            this.reports.loadCells(this.grid, container, 'render', subject);

            editor.on('shown.bs.tab', (e) => {
                let tab_id = $(e.target).attr('data-bs-target');
                let tab = $(tab_id);
                utils.j().initElements(tab);
            });
        }
    }
}

export default ReportRender;
